import React from 'react';

const SupplierInfo = ({ formData, onFormChange }) => {
  return (
    <div className="form-card">
      <div className="card-header">
        <h3>🏢 Supplier Information</h3>
      </div>
      <div className="card-content">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="supplierName">Supplier Name *</label>
            <input
              type="text"
              id="supplierName"
              value={formData.supplierName}
              onChange={(e) => onFormChange('supplierName', e.target.value)}
              placeholder="Enter supplier name"
              className="modern-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="additionalText">Extraction instructions</label>
            <textarea
              id="additionalText"
              value={formData.additionalText}
              onChange={(e) => onFormChange('additionalText', e.target.value)}
              placeholder="Example: PO/order number may be random numeric or start with O; extract it exactly as printed."
              rows="4"
              className="modern-textarea"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierInfo;